import React, { useState } from "react";
import { Grid2 } from "@mui/material";
import DownloadsTable from "./DownloadsTable";
import NewDownloadMain from "./NewDownloadMain";

const DataDownloadMain = () => {
  const [showNewDownload, setShowNewDownload] = useState(false);

  return (
    <Grid2 container flexDirection="column" gap={1} sx={{ px: 3, py: 2 }}>
      {!showNewDownload ? (
        <DownloadsTable onNewDownload={() => setShowNewDownload(true)} />
      ) : (
        <NewDownloadMain onBack={() => setShowNewDownload(false)} />
      )}
    </Grid2>
  );
};

export default DataDownloadMain;
